import { render } from "./FlowProfiles.vue?vue&type=template&id=73536897&scoped=true"
import script from "./FlowProfiles.vue?vue&type=script&lang=js"
export * from "./FlowProfiles.vue?vue&type=script&lang=js"

import "./FlowProfiles.vue?vue&type=style&index=0&id=73536897&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73536897"]])

export default __exports__